import Swal from "sweetalert2";
import {logoutUser} from "@/request";

function returnCustomConfirmationBody(type, trans_type, html, hasConfirmation) {
    const mapper = {
        disbursement: {
            transactions: 'payables',
            date_type: 'disbursement',
            date_label: 'cheque'
        }
    }

    const confirmation_message =
        `<div v-if="hasConfirmation">
            To continue, please click Confirm.
        </div>`
    if(type === 'payment_date_warning') {
        return `
        <h5 class="mb-3">Warning</h5>
        <div class="text-start">
            <div class="mb-1">
                One or more ${trans_type === 'disbursement' ? 'payables' : 'receivables'} 
                are dated after the ${mapper[trans_type]['date_label'] ?? ''} date.
            </div>
            <div class="mb-1">
                Please check that selected transactions are correct before continuing.
            </div>
            ${hasConfirmation ? confirmation_message : ''}
            
        </div>`
    }

    return html
}

export const AlertConfigurations = {
    triggerSwal(action, text) {
        Swal.fire({
            title: action,
            iconHtml: "<div class='spinner-border fs-2 text-secondary' style='width: 5rem; height: 5rem;' role='status'></div>",
            showConfirmButton: false,
            text: text,
            allowOutsideClick: false,
            allowEscapeKey: false
        })
    },
    confirmLogOutAlert (){
        return Swal.fire({
            title: 'Logout?',
            text: 'Are you sure you want to logout?',
            confirmButtonText: 'Logout',
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: 'var(--app-dark-gray)',
            showCancelButton: true,
            }).then((logout) => {
                if(logout.isConfirmed){
                    logoutUser()
                }
            })
        },
    successAlert(text, action) {
        return Swal.fire({
            title: action,
            icon: `success`,
            text: text,
            showConfirmButton: false,
            timer: 3000
        })
    },
    async confirmAlert(text, action) {
      return await Swal.fire({
        title: action,
        icon: "question",
        text: text,
        confirmButtonText: 'Confirm',
        confirmButtonColor: '#0d6efd',
        cancelButtonColor: 'var(--app-dark-gray)',
        showCancelButton: true,
      }).then(response => response.isConfirmed)
    },
    async customConfirmAlert(text, action, buttonTxt, type = null, html = null, transaction= 'disbursement', icon="warning", showBtn = true) {
        return await Swal.fire({
            title: action,
            icon: icon,
            text: text,
            html: returnCustomConfirmationBody(type, transaction, null, showBtn),
            confirmButtonText: buttonTxt,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: 'var(--app-dark-gray)',
            showCancelButton: showBtn,
            showConfirmButton: showBtn,
        }).then(response => response.isConfirmed)
    },
    async confirmDeleteAlert(text, action, btnText = null) {
        return await Swal.fire({
            title: action,
            icon: "warning",
            iconColor: '#FF4343',
            text: text,
            confirmButtonText: btnText ? 'Proceed to ' + btnText : 'Proceed to delete',
            confirmButtonColor: '#FF4343',
            cancelButtonColor: 'var(--app-dark-gray)',
            showCancelButton: true,
        }).then(response => response.isConfirmed)
    },
    async confirmVoidAlert(text, action) {
        return await Swal.fire({
            title: action,
            icon: "warning",
            iconColor: '#FF4343',
            text: text,
            confirmButtonText: 'Proceed to delete',
            confirmButtonColor: '#FF4343',
            cancelButtonColor: 'var(--app-dark-gray)',
            showCancelButton: true,
        }).then(response => response.isConfirmed)
    },
    async confirmCancellationAlert(text, action, confirm_text) {
        return await Swal.fire({
            title: action,
            icon: "warning",
            iconColor: '#FF4343',
            text: text,
            confirmButtonText: confirm_text,
            confirmButtonColor: '#FF4343',
            cancelButtonColor: 'var(--app-dark-gray)',
            showCancelButton: true,
        }).then(response => response.isConfirmed)
    },
    async confirmLeaveFormAlert() {
        return await Swal.fire({
            title: 'You have unsaved changes!',
            icon: 'warning',
            text: 'You will lose all your changes. Are you sure you wish to leave?',
            confirmButtonText: 'Proceed to leave',
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: 'var(--app-dark-gray)',
            showCancelButton: true,
        }).then(response => response.isConfirmed)
    },
    failedAlert (text, action) {
        return Swal.fire({
            title: action,
            icon: `error`,
            text: text,
            timer: 3000
        })
    },
    loadingAlert (text, action) {
        return Swal.fire({
            title: action,
            iconHtml: "<div class='spinner-border fs-2 text-secondary' style='width: 5rem; height: 5rem;' role='status'></div>",
            showConfirmButton: false,
            text: text,
            timer: 800,
            allowOutsideClick: false,
            allowEscapeKey: false
        })
    },
    infoAlert(text, action) {
        return Swal.fire({
            title: action,
            icon: 'warning',
            text: text,
            timer: 3000
        })
    },
    toastNotification (text, action, icon) {
        return Swal.fire({
            toast: true,
            title: action,
            icon: icon,
            text: text,
            timer: 2250,
            showConfirmButton: false,
            position: 'top-right'
        })
    }
}